import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService, MessagesServices } from '../../api/';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { Observable } from 'rxjs/Observable';
import { MdDialogRef } from '@angular/material';

@Component({
    selector: 'edit-screen-name',
    templateUrl: './edit-screen-name.html',
})
export class EditScreenNameDialog implements OnInit, OnDestroy {
    private screenName: string = '';
    public errorArray: Array<any> = new Array<any>();
    private inputSubscriber: any = null;
    private checkAvailibilitySubscriber = null;
    private loading: boolean = false;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    public onlineOffline: boolean = navigator.onLine;

    constructor(public dialogRef: MdDialogRef<EditScreenNameDialog>, private sm: MessagesServices, private userService: UserService, private toastyService:
        ToastyService) {
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false;});

        this.messages = this.sm.messags;
        this.setMessages();
    }

    ngOnInit() {
        this.inputSubscriber = this.inputChanges(300).subscribe(
            input => this.trimSpaces()
        );
    }

    /**
     * getting system messages
    **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_SCREEN_NAME_UPDATED_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
            }
        }
    }

    changeScreenName() {
        this.loading = true;
        if(this.onlineOffline) {
            this.userService.checkScreenNameAvailibility(this.screenName).subscribe((res) => {
                if (res === true) {
                    this.errorArray['screenname'] = '';
                    this.userService.changeScreenName(this.screenName).subscribe((res) => {
                        let toastOptions: ToastOptions = {
                            title: this.title1,
                            msg: this.msg1,
                            showClose: true,
                            timeout: 2000,
                            theme: 'default'
                        };
                        this.toastyService.success(toastOptions);
                        this.dialogRef.close(true);
                        this.loading = false;
                    }, (err) => {
                        this.handleErrors(err);
                        this.loading = false;
                    });
                } else {
                    this.errorArray['screenname'] = 'This screen name is not available.';
                    this.loading = false;
                }
            },
            (error) => {
                console.log(error);
            });
        } else {
            this.loading = false;
        }
    }

    trimSpaces() {
        this.screenName = this.screenName.replace(/\s+/g, '_');
        this.screenName = this.screenName.replace(/_{2,}/g, '_');
        this.screenName = this.screenName.replace(/-{2,}/g, '-');
        if (this.checkAvailibilitySubscriber != null) {
            this.checkAvailibilitySubscriber.unsubscribe();
        }
        this.loading = true;
        this.checkAvailibilitySubscriber = this.userService.checkScreenNameAvailibility(this.screenName).subscribe((res) => {
            if (res === false) {
                this.errorArray['screenname'] = 'This screen name is not available.';
            } else {
                this.errorArray['screenname'] = '';
            }
            this.loading = false;
        }, (err) => { this.loading = false; });
    }

    handleErrors(err: any) {
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }

    getScreenNameError() {
        let err = {
            length: true,
            initial: true,
            end: true,
            full: true
        };
        let INITAL_REGEXP = /^[a-zA-Z0-9]{1}/;
        let END_REGEXP = /[a-zA-Z0-9]$/;
        let REGEXP = /^[a-zA-Z0-9]+([a-zA-Z0-9_\-.])+[a-zA-Z0-9]$/;
        if (this.screenName.length < 4) {
            err.length = false;
        } else if (!INITAL_REGEXP.test(this.screenName)) {
            err.initial = false;
        } else if (!END_REGEXP.test(this.screenName)) {
            err.end = false;
        } else if (!REGEXP.test(this.screenName)) {
            err.full = false;
        }
        this.errorArray['screennameValidation'] = err;
    }

    closeDialog() {
        this.dialogRef.close(false);
    }

    emitInput: (event: KeyboardEvent) => void;

    //sets up emitInput to start sending values
    inputChanges(debounce: number): Observable<string> {
        return Observable.create(observer => {
            this.emitInput = (event: KeyboardEvent) => {
                observer.next((<HTMLInputElement>event.target).value);
            };
        }).distinctUntilChanged().debounceTime(debounce);
    }

    ngOnDestroy() {
        this.inputSubscriber.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/edit-screen-name/edit-screen-name.ts